import type { ModalStoreType } from '@/features/ui/store/modal/modal.store'
import modalsStore from '@/features/ui/store/modal/modal.store'

/**
 * Hook Playwright : ouvrir / fermer une modale du store sans rejouer le parcours
 * UI (trop long / flaky pour un audit contraste de TOUTES les modales).
 * Inactif hors e2e : le flag est posé par `addInitScript` avant le boot.
 */

export type E2eOpenModalPayload = {
  name: ModalStoreType['name']
  step?: string | null
  attachedData?: Record<string, unknown> | null
}

declare global {
  interface Window {
    __E2E_MODAL_HOOK__?: boolean
    __e2eOpenModal?: (payload: E2eOpenModalPayload) => void
    __e2eCloseModal?: (name: ModalStoreType['name']) => void
    __e2eSetModalStep?: (name: ModalStoreType['name'], step: string) => void
  }
}

export function registerE2eModalHook() {
  if (typeof window === 'undefined' || !window.__E2E_MODAL_HOOK__) return

  window.__e2eOpenModal = ({ name, step, attachedData }) => {
    if (attachedData) {
      modalsStore.updateModalAttachedData(name as never, attachedData as never)
    }
    if (step) {
      modalsStore.setModalStep(name as never, step as never)
    }
    modalsStore.toggleModal(name, true)
  }

  window.__e2eCloseModal = (name) => {
    modalsStore.toggleModal(name, false)
  }

  window.__e2eSetModalStep = (name, step) => {
    modalsStore.setModalStep(name as never, step as never)
  }
}
